import React from 'react';
import UnifiedClientOnboarding from './UnifiedClientOnboarding';

const NewClientOnboarding = ({ callbackFromParent, defaultData = {} }) => {
  return (
    <UnifiedClientOnboarding
      callbackFromParent={callbackFromParent}
      defaultData={defaultData}
    />
  );
};

export default NewClientOnboarding;
